export const routes = {
    HOME: "/",
    LOGIN: "/login",
    FORGOT_PASSWORD: "/forgot-password",
    ONBOARDING: "/onboarding",
    DASHBOARD: "/Dashboard",
    BANNER: "/Banner",
    Drivers: "/Drivers",
    CUSTOM_NOTIFICATIONS: "/notifications",
    CATEGORIES: "/Categories",
    SETTINGS: "/Setting",
    APP: "/App",
    PLAYLIST: "/Playlist",
    MEDIA_VIEW: "/MediaView",
    PAYMENT: "/Payment",
    Warehouse: "/Warehouse",
    Orders: "/Orders",
    ORDER_DETAILS: "/Orders/:id",
    SELECT_PLAN: "/plans/select",



    //DashboardSuper
    SUPER_DASHBOARD: "/DashboardSuper",
    
    // API Documentation
    API_DOCUMENTATION: "/api-documentation",
    
    // Plans Management (Super Admin)
    PLANS: "/admin/plans",
    PLAN_CREATE: "/admin/plans/create",
    PLAN_EDIT: "/admin/plans/edit/:id",
    
    // Store Details (Super Admin)
    STORE_CREATE: "/admin/stores/create",
    STORE_DETAILS: "/admin/stores/:id",

    // Live Tracking
    LIVE_TRACKING: "/live-tracking",

    // User Guide / FAQ
    USER_GUIDE: "/user-guide",

    // Staff Management
    STAFF: "/Staff",

    // Contact & Support Management
    SUPPORT: "/support",

    // Franchise Management
    FRANCHISE: "/franchise",
    FRANCHISE_CREATE: "/franchise/create",
    FRANCHISE_EDIT: "/franchise/edit/:id",
    FRANCHISE_DETAIL: "/franchise/:id/orders",
    FRANCHISE_DASHBOARD: "/franchise-dashboard",
}  